import {
  buildEntryArraySum,
  buildSumGroup,
  matchPrintedGeneralPayrollList,
  sumNumberOrArray,
} from "./shared";
import { TAX_ROW_AMOUNT } from "./tax";

export const GENERAL_PAYROLL_SUMS = {
  peraAda: sumNumberOrArray("$peraAda"),
  overpaymentBasic: sumNumberOrArray("$overpaymentBasic"),
  overpaymentPeraAda: sumNumberOrArray("$overpaymentPeraAda"),
  earnedBasic: sumNumberOrArray("$earnedBasic"),
  earnedPeraAda: sumNumberOrArray("$earnedPeraAda"),
  tax: TAX_ROW_AMOUNT,
  mandatoryDeductions: buildEntryArraySum("$contributions"),
  loansOtherDeductions: buildEntryArraySum("$deductions", ["tax"]),
  netAmount: sumNumberOrArray("$netAmount"),
};

export const GENERAL_PAYROLL_ONLY_FIELDS = Object.keys(
  GENERAL_PAYROLL_SUMS,
).filter((field) => field !== "tax");

export const GENERAL_PAYROLL_LOOKUPS = [
  {
    $lookup: {
      from: "payroll",
      let: { employeeId: "$_id" },
      pipeline: [
        { $match: { $expr: { $eq: ["$employee.id", "$$employeeId"] } } },
        ...matchPrintedGeneralPayrollList(),
        { $group: buildSumGroup(null, GENERAL_PAYROLL_SUMS) },
      ],
      as: "generalPayrollLookup",
    },
  },
];

export function getGeneralPayrollByEmployeePipeline(employeeIds = []) {
  return [
    { $match: { "employee.id": { $in: employeeIds } } },
    ...matchPrintedGeneralPayrollList(),
    { $group: buildSumGroup("$employee.id", GENERAL_PAYROLL_SUMS) },
    {
      $project: {
        _id: 0,
        employeeId: "$_id",
        ...Object.fromEntries(
          Object.keys(GENERAL_PAYROLL_SUMS).map((key) => [key, 1]),
        ),
      },
    },
  ];
}
